export default __webpack_public_path__ + "static/media/Middot.38d636ad.svg";